<template>
  <div class="PList">
    <section class="py-8">
      <div class="container mx-auto px-6">
        <!-- <div class="text-center mb-16">
          <h2 class="text-3xl font-serif text-slate-900 dark:text-white mb-4">
            Featured Products
          </h2>
          <div class="w-16 h-1 bg-primary mx-auto"></div>
        </div> -->

        <navi-bar :ptitle="ptitle" />

        <div class="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div
            v-for="(product, index) in list"
            :key="'prod-' + index"
            class="group cursor-pointer"
          >
            <div
              class="aspect-square dark:bg-slate-800 rounded-2xl p-6 mb-4 flex items-center justify-center overflow-hidden"
              @click="onProductClick(product)"
            >
              <img
                :alt="product.title"
                class="w-full h-full object-contain group-hover:scale-110 transition-transform duration-300"
                :src="product.url"
              />
            </div>
            <h3
              class="text-sm font-medium text-center text-slate-800 dark:text-slate-200 line-clamp-2"
            >
              {{ product.message }}
            </h3>
          </div>
        </div>

        <!-- <div class="mt-16 text-center">
          <button
            class="inline-flex items-center gap-2 border border-primary text-primary px-8 py-3 rounded-full hover:bg-primary hover:text-white transition-all font-semibold"
          >
            View More Products <i class="material-icons text-sm">grid_view</i>
          </button>
        </div> -->
      </div>
    </section>
  </div>
</template>

<script>
import NaviBar from './NaviBar'
export default {
  name: 'PList',
  components: {
    NaviBar
  },
  props: ['ptype'],
  watch: {
    ptype: {
      handler(val) {
        if (val) {
          if (val === 'LSR') {
            this.list = this.LSR
            this.ptitle = 'LSR Silicone Rubber'
          } else {
            this.list = this.HTV
            this.ptitle = 'HTV Silicone Rubber'
          }
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      ptitle: '',
      list: [],
      HTV: [
        {
          url: require('@/assets/product/Electric Insulation Silicone Rubber.jpg'),
          message: 'Electric Insulation Silicone Rubber'
        },
        {
          url: require('@/assets/product/Fire Retardant Silicone Rubber.jpg'),
          message: 'Fire Retardant Silicone Rubber'
        },
        {
          url: require('@/assets/product/General Purpose Silicone Rubber For Molding.jpg'),
          message: 'General Purpose Silicone Rubber For Molding'
        },
        {
          url: require('@/assets/product/High Resilience Silicone Rubber.jpg'),
          message: 'High Resilience Silicone Rubber'
        },
        {
          url: require('@/assets/product/High Tear Strength Silicone Rubber For Molding.jpg'),
          message: 'High Tear Strength Silicone Rubber For Molding'
        },
        {
          url: require('@/assets/product/High Temperature Resistant Silicone Rubber.jpg'),
          message: 'High Temperature Resistant Silicone Rubber'
        },
        {
          url: require('@/assets/product/High Transparent Fumed Silicone Rubber.jpg'),
          message: 'High Transparent Fumed Silicone Rubber'
        },
        {
          url: require('@/assets/product/Roller Silicone Rubber.jpg'),
          message: 'Roller Silicone Rubber'
        },
        {
          url: require('@/assets/product/Silicone Rubber for Extrusion.jpg'),
          message: 'Silicone Rubber for Extrusion'
        }
      ],
      LSR: [
        {
          url: require('@/assets/product/High Transparency Silicone Rubber.jpg'),
          message: 'High Transparency Silicone Rubber'
        },
        {
          url: require('@/assets/product/Liquid Silicone Rubber for  Food Kitchen.jpg'),
          message: 'Liquid Silicone Rubber for  Food Kitchen'
        },
        {
          url: require('@/assets/product/Liquid Silicone Rubber for Baby Care.jpg'),
          message: 'Liquid Silicone Rubber for Baby Care'
        },
        {
          url: require('@/assets/product/Liquid Silicone Rubber for Cable Accessories.jpg'),
          message: 'Liquid Silicone Rubber for Cable Accessories'
        },
        {
          url: require('@/assets/product/Liquid Silicone Rubber for Medical.jpg'),
          message: 'Liquid Silicone Rubber for Medical'
        },
        {
          url: require('@/assets/product/Liquid Silicone Rubber for Molding.jpg'),
          message: 'Liquid Silicone Rubber for Molding'
        },
        {
          url: require('@/assets/product/Self-Adhesive Liquid Silocone Rubber.jpg'),
          message: 'Self-Adhesive Liquid Silocone Rubber'
        }
      ]
    }
  },
  methods: {
    onProductClick(p) {
      // console.log(JSON.stringify(p))
      // 查询到图片类型
      const purl = p.url
      const type = purl.slice(-3)
      this.$router.push({
        path: '/products-details',
        query: { n: p.message, l: this.ptitle, t: type }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/page/Products/pList.vue